import { render, staticRenderFns } from "./AddSource.vue?vue&type=template&id=2d24f4f8&lang=html&"
import script from "./AddSource.vue?vue&type=script&lang=js&"
export * from "./AddSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports